module.exports = __webpack_public_path__ + "c0af89e68fa0c431f501ccd0aa4b5cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/guidelogo.png
// module id = 637
// module chunks = 0